import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';

import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Rating } from '../../legacy';
import { Heading, Button } from '@restworld/ui-ds-base';

import { companyProfileAtom, fullRatingAtom } from '../../job-position/job-position.atoms';
import { cn } from '@restworld/utils-common';

export const SingleRating = () => {
  const setFullRating = useSetAtom(fullRatingAtom);
  const { reviewRating, reviewNumbers } = useAtomValue(companyProfileAtom);

  const clickHandler = useCallback(() => {
    if (reviewNumbers) setFullRating(true);
  }, [reviewNumbers, setFullRating]);

  return reviewNumbers ? (
    <Wrapper>
      <RatingWrapper>
        <Rating rating={reviewRating || 0} />
        <Heading>{reviewRating?.toString() ?? ''}</Heading>
        <Heading color="muted" weight="light">
          {`(${reviewNumbers} review${reviewNumbers > 1 ? 's' : ''})`}
        </Heading>
      </RatingWrapper>
      <Button StartIcon={ChevronRightIcon} variant="ghost" onClick={clickHandler} />
    </Wrapper>
  ) : null;
};

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex justify-between', className)} {...props} />
);
const RatingWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex gap-1', className)} {...props} />
);
